

<style scoped lang="less" > 
.content{padding: 20px;}
//日期组件自定义样式
.datePlug{
  width: 124px; height: 24px;padding: 2px 8px; white-space: nowrap; border: 1px solid #434343;
  border-radius: 4px; font-size: 0;
  a{
    display: inline-block;vertical-align: top;width: 14px;height: 20px;position: relative;
    // border: 1px solid #000 ;
    &:before {
      content: "";display: block;position: absolute;left: 50%;top:50%;
      width: 8px;height: 8px;border-top: 2px solid #434343;border-left: 2px solid #434343;
      transform: translate(-50%,-50%) rotate(-45deg);
    }
    &.day_r{
      &:before {
        transform: translate(-50%,-50%) rotate(135deg);
      }
    }
  }
  //日期
  .daseDateBox{
    display: inline-block;vertical-align: top;font-size: 12px;line-height: 20px;width: 80px;height: 20px;
    padding-left: 16px;position: relative;
    &:before {
      content: "";display: block;position: absolute;left: 0;top:3px;
      width: 12px;height: 12px; background: #e5d543;
    }
  }

} 


//

.pickerPlug{
  width: 124px; height: 24px;padding: 2px 10px 2px 8px; white-space: nowrap; border: 1px solid #434343;
  border-radius: 4px; font-size: 0;position: relative;
  &:before {
      content: "";display: block;position: absolute;right: 2px;top:9px;
      width: 8px;height: 8px;border-top: 2px solid #434343;border-left: 2px solid #434343;
      transform: translate(-50%,-50%) rotate(-135deg);
  }
  //下拉插件
  .dasePickerBox{
    width: 100%;height: 100%;font-size: 12px;line-height: 20px !important;
  }
}

//其它
.APItext{
  padding: 10px;
  p{font-size: 14px;line-height: 1.5;color: #434343;}
}
</style>
<template>
  <div id="indexComponent">
    <Header/>
    <!-- 内容 -->
    <div class="content">
      <!-- 时间框 -->
      <div class="datePlug">
        <a href="javascript:void(0);" @click="nextDay(-1)" class="day_l" ></a>
        <!-- 时间组件 -->
        <DaseDatetime class="daseDateBox" 
          ref="DaseDatetime"  
          :format="'DD/MM WW'" 
          :minDate="'-7'" 
          :maxDate="'7'" 
          :showToday="true" 
          @changeTime="changeTime" 
          :today="today111"
        ></DaseDatetime>
        <a href="javascript:void(0);" @click="nextDay(1)" class="day_r" ></a>
      </div>
      <!-- 按钮 -->
      <div class="APItext">
        
        <p>:today      设定今天为哪一天，可以输入'2020-01-01'，单数月份日期前面必须补0,只能传字符串 :today="'2023-01-01'" </p>
        <p>:minDate    最小时间，可以输入'2020-01-01'也可以是数字，7就是7天后，-7就是7天前，传值必须是字符串</p>
        <p>:maxDate    最大时间，可以输入'2020-01-01'也可以是数字，7就是7天后，-7就是7天前，传值必须是字符串</p>
        <p>:showToday    是否显示今天选项,true false 默认 false</p>
        <p>:format       'YYYY-MMM-DD hh-mm-ss WW',默认'YYYY-MMM-DD'</p>
        <p>:lang         'zh-CN'中文；’en-US'英文，默认英文</p>
        <p>@changeTime    选中后回调，返回参数为日期</p>
      </div>
      <el-button @click="getTime()">获取时间</el-button>
      <!-- <el-button @click="AAA()">获取时111间</el-button> -->
      <el-button @click="setTime()">控件时间修改到：2023-10-11</el-button>
      <div style="padding-top: 100px;">

        <el-button @click="hasTimeCancel()">关闭弹窗</el-button>
      </div>
    </div>
    
    <!-- 内容 -->
    <div class="content">
      <!-- 时间框 --> 
      <div class="pickerPlug"> 
        <DasePicker class="dasePickerBox" 
          ref="DasePicker"  
          :options="pickerList"  
          @changeTime="changePicker"
        ></DasePicker>
      </div> 
      <div style="margin-top:10px;">
        <el-button @click="setPicker()">填充数据</el-button>
        <el-button @click="setPickerValue()">填充选中</el-button>
        <el-button @click="closePickerValue()">强制关</el-button>
        <el-button @click="closePickerValue(true)">强制开</el-button>
        <el-button @click="getPicker()">获取当前数据</el-button> 
      </div>
    </div>
  <!-- 按钮 -->
  <!--    -->
  
  </div> 
</template>
<script>
  import { mapState, mapMutations, mapActions } from 'vuex';
  
  import Header from '@/components/header.vue';
  import DaseDatetime from '@/components/baseDatetime.vue';
  import DasePicker from '@/components/basePicker.vue';
	export default {
    name: 'index',
    components: {
      Header,
      DaseDatetime,
      DasePicker
    },
    
    props: {},

		data(){
			return{
        today111:'2023-01-08',
        pickerList:[],
        optionsPicker: [{
          value: 'a1',
          name: '黄金糕'
        }, {
          value: 'a2',
          name: '双皮奶'
        }, {
          value: 'a3',
          name: '蚵仔煎'
        }, {
          value: 'a4',
          name: '龙须面'
        }, {
          value: 'a5',
          name: '北京烤鸭'
        }],
         radio: '1',
         checked: true,
         pickedTime: '', // 存储选择的时间
         show: false,
        selectedTime: new Date(),
        
        
			}
		},

    computed: {
      ...mapState('home', ['dataList']),
      // dataList () {
      //     return this.$store.state.home.dataList;
      // }
      ws() {
        return socketServer.Instance
      }
    },

		methods:{
      ...mapMutations('home', ['setDataList']),
      //=》下拉控件==begin
        // AAA(){
        //   this.today111='2023-01-11'
        // },
        //填充选中
        setPickerValue(){
          var value=this.$refs.DasePicker.setValue(1);  
          console.log('value',value);
        },
        //填充数据
        setPicker(){
          this.pickerList=[{
            value: 'a1',
            name: '黄金糕'
          }, {
            value: 'a2',
            name: '双皮奶'
          }, {
            value: 'a3',
            name: '蚵仔煎'
          }, {
            value: 'a4',
            name: '龙须面'
          }, {
            value: 'a5',
            name: '北京烤鸭'
          }]; 
        },
        closePickerValue(val=false){
          this.$refs.DasePicker.closePicker(val);  
        },
        //下拉发生改变时
        changePicker(val){ 
          console.log('选中对象为：',val);
        }, 
        //获取当前数值 
        getPicker(){
          var value=this.$refs.DasePicker.getValue();  
          console.log('获取当前数值为：',value);
        }, 
      //=》时间控件==begin
        //选取时间
        changeTime(val){
          console.log('时间控件选中返回',val);
        },
        //获取时间控件前后天时间
        nextDay(disDay){
          let returnDay = this.$refs.DaseDatetime.setTime(disDay);
          console.log('左右按钮获取到时间',returnDay);
        },
        //关闭弹出 
        hasTimeCancel(){
          this.$refs.DaseDatetime.onTimeCancel();
       
        }, 
          //获取控件时间 
        getTime(){
          var timeDay=this.$refs.DaseDatetime.getTime();
          console.log('getTime',timeDay);
        }, 
        //修改控件时间 
        setTime(){
          this.$refs.DaseDatetime.setTime('2023-10-11');
          console.log('时间修改到','2023-10-11');
        }, 


		},

		created(){
		},

    destroyed() {
    },
	};

</script>


// WEBPACK FOOTER //
// ./src/views/demoPlug.vue